import { Props_SnippetInstagram } from "./Instagram.props";
import { CompileHeadingToSpan} from '../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler'

export const SnippetInstagram = (props: Props_SnippetInstagram) => {
  const { heading, instagram } = props;

  const classHeadingVisibility = heading.visibility.value
    ? ""
    : "accessible-heading";

  return (
    <section className="snippet-instagram">
      <div className="snippet-instagram__container">
        <div className="snippet-instagram__header">
        <h2 className={`snippet-instagram__heading ${classHeadingVisibility}`}>{CompileHeadingToSpan(heading.content.value || '')}</h2>
        </div>

       {instagram &&  <div className="snippet-instagram__script-container">
          <div id={instagram?.flockerid?.value}></div>

          <script src={instagram?.script?.value} async></script>

        </div>}
      </div>
    </section>
  );
};
